import React from 'react';
import { useSelector } from 'react-redux';
import { useDroneProvider } from '@src/core/features';
import {
  selectEndedMissionSerials,
  selectOptimisticMissionSerials,
} from '@src/features/drone/redux/selectors';
import { partitionDronesPageDrones } from '@src/features/drone/utils/operational-drones';

export const useDronesPageDrones = () => {
  const { drones: allDrones, refetch, isLoading } = useDroneProvider();
  const optimisticMissionSerials = useSelector(selectOptimisticMissionSerials);
  const endedMissionSerials = useSelector(selectEndedMissionSerials);

  const { visibleDrones, idleDrones, missionDrones, updateRequiredDrones } = React.useMemo(
    () => partitionDronesPageDrones(allDrones, optimisticMissionSerials, endedMissionSerials),
    [allDrones, optimisticMissionSerials, endedMissionSerials],
  );

  return {
    allDrones,
    visibleDrones,
    idleDrones,
    missionDrones,
    updateRequiredDrones,
    refetch,
    isLoading,
  };
};
